<template>
  <div class="boxall">
    <div class="title">供应链金融</div>
    <div class="boxnav">
      <div class="bg-image">
        <div class="content">
          <div class="item-box">
            <div class="item-icon">
              <img src="../assets/images/daikuan.png" alt="icon" />
            </div>
            <div class="item-info">
              <div class="item-value">
                <span class="num">36</span>
                <span class="unit">户</span>
              </div>
              <div class="item-label">贷款主体</div>
            </div>
          </div>

          <div class="item-box">
            <div class="item-icon">
              <img src="../assets/images/loan_money.png" alt="icon" />
            </div>
            <div class="item-info">
              <div class="item-value">
                <span class="num">15.8</span>
                <span class="unit">万元</span>
              </div>
              <div class="item-label">发放金额</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SupplyFinance'
}
</script>

<style scoped>
.bg-image {
  width: 100%;
  height: 100%;
  background: url('../assets/images/supplychain-bg.jpg') no-repeat center center;
  background-size: 100% 100%;
  border-radius: 12px;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.content {
  height: 35%;
  background: #303030b0;

  flex: 0 0 35%; /* 纵向上高度百分比 */
  height: 100%;
  display: flex;
  flex-direction: row;
  padding: 0 16px;
  box-sizing: border-box;
}

.item-box {
  flex: 1;
  width: 100%;
  display: flex;
  align-items: center; /* 垂直居中 */
  padding: 0 20px;
  box-sizing: border-box;
}

.item-icon {
  height: 40px;
  width: 40px;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  margin-left: 16px;
}

.item-icon img {
  width: 32px;
  height: 32px;
}

/* 右侧文字区域 — 垂直居中 */
.item-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 4px;
}

/* 第一行：数字 + 单位 */
.item-value {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.num {
  font-size: 28px;
  font-weight: bold;
  color: #00cfff;
  font-family: ds-digitalnormal !important;
}

.unit {
  font-size: 16px;
  color: #7ecfea;
}

/* 第二行：描述 */
.item-label {
  font-size: 14px;
  color: #8fb8c8;
  display: flex;
  /* margin-top: 4px; */
}
</style>
